import {getStateXml, getCompressedData} from '../../../_shared/GWTBridge/invoke/server';
import {buildFormServerCall} from '../../services/formService';
import {Form} from '../../Form/stores/Form';

export function formListMailInterfaces(form: Form) {
    const methodName = 'FormListMailInterfaces';
    const reason = 'Form List Mail Interfaces';

    const statexml = getStateXml(form.session);
    const parameters = {statexml: [statexml]};

    return buildFormServerCall(methodName, parameters, reason, false);
}

export function formSendMailInterfaces(form: Form, lines: boolean, data) {
    const methodName = 'FormSendMailInterfaces';
    const reason = 'Form Send Mail Interfaces';

    const statexml = getStateXml(form.session);
    const xml = getCompressedData(data, 'MailInterfaces');

    const parameters = {
        statexml: [statexml],
        lines: [lines ? 'true' : 'false'],
        xml: [xml.compressed]
    };
    return buildFormServerCall(methodName, parameters, reason, false);
}
